<template>
  <Drawer
    v-model="showDrawer"
    width="80"
    title="配置可见学校"
    @on-close="handleCloseDrawer"
  >
    <div class="base-info">
      <BaseDetailsInfo v-if="showDrawer" :config-id="configId" :create-time="createTime" :operate-time="operateTime" :operator-name="operatorName"></BaseDetailsInfo>
      <div class="head">配置使用机构：</div>
      <div class="table-wrap">
        <Table :columns="columns" :data="tableList" border>
          <template slot="action" slot-scope="{ row, index }">
            <Button
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="hadnleSet()"
            >设置学校</Button>
          </template>
        </Table>
      </div>
    </div>
    <!-- <div class="formbtnbox-430-bottom">
      <Button @click="handleGoBack">返回</Button>
    </div> -->
    <ChooseSchoolModal ref="chooseSchoolModal" @on-finish="onSchFinish">
      <template #remark>
        <RemarkCard>
          <p>
            请根据<span style="color: red">监管银行</span>选择对应的学校，不可选错！点击搜索立即查询。
          </p></RemarkCard>
      </template>
    </ChooseSchoolModal>
  </Drawer>
</template>

<script>

import BaseDetailsInfo from '../assets/components/BaseDetailsInfo.vue';
import ChooseSchoolModal from '../assets/components/ChooseSchoolModal.vue';
import RemarkCard from '@c/Base/RemarkCard.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    BaseDetailsInfo,
    ChooseSchoolModal,
    RemarkCard
  },
  data() {
    return {
      hasChangeData: false,
      createTime: '',
      operateTime: '',
      operatorName: '',
      showDrawer: false,
      configId: '',
      tableList: [],
      columns: [{
        title: '使用学校',
        key: 'schoolName'
      }, {
        title: '学校数',
        width: 180,
        key: 'schoolNumber'
      }, {
        title: '操作',
        width: 150,
        slot: 'action'
      }],
      isSaveing: false,
      saveSchoolInfos: []

    };
  },
  computed: {

  },
  methods: {
    openDrawer({ inAccountType, configId, bankId, bankName, createTime, operateTime, operatorName }) {
      this.hasChangeData = false;
      this.configId = configId;
      this.createTime = createTime;
      this.operateTime = operateTime;
      this.operatorName = operatorName;
      this.getDivideConfigdSchoolList();
      this.showDrawer = true;
    },
    handleCloseDrawer() {
      if (this.hasChangeData) {
        this.$emit('refreshData');
      }
    },
    async saveDivideConfigRelateSch(schoolInfos) {
      this.$Spin.show();
      const res = await orderCenterApi.saveDivideConfigRelateSch({
        configId: this.configId,
        schoolInfos: schoolInfos
      });
      this.$Spin.hide();
      if (res.status == 200) {
        this.$Message.success('设置成功');
        this.$refs.chooseSchoolModal.handleClosure();
        this.getDivideConfigdSchoolList();
      }
    },
    // 获取设置的学校
    async getDivideConfigdSchoolList() {
      const res = await orderCenterApi.getDivideConfigdSchoolList({
        configId: this.configId
      });
      if (res.status == 200) {
        this.initTableData(res.message);
      }
    },
    initTableData(data) {
      const schoolNames = []; const schoolInfos = [];
      data.forEach(item => {
        schoolNames.push(item.schoolName);
        schoolInfos.push({
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });
      this.tableList = [{
        schoolName: schoolNames.join('、'),
        schoolInfos: schoolInfos,
        schoolNumber: schoolNames.length
      }];
    },
    hadnleSet() {
      const data = this.tableList[0].schoolInfos.map((item) => {
        return {
          name: item.schoolName,
          orgId: item.schoolId,
          id: item.schoolId
        };
      });

      this.$refs.chooseSchoolModal.handleOpen(data);
    },
    handleCheckAllForm(data) {
      const schoolInfos = [];
      data.forEach(item => {
        schoolInfos.push({
          schoolId: item.schoolId,
          schoolName: item.schoolName
        });
      });
      this.saveDivideConfigRelateSch(schoolInfos);
    },
    // handleGoBack() {
    //   this.$router.push({
    //     name: 'orderCenter_profitSharing_index'
    //   });
    // },
    // 选择学校
    onSchFinish(data) {
      this.hasChangeData = true;
      data.forEach(item => {
        item.schoolId = item.orgId;
        item.schoolName = item.name;
      });
      //  this.initTableData(data)
      this.handleCheckAllForm(data);
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  background: rgb(247, 248, 250);
  line-height: 40px;
  font-weight: 700;
  padding: 0 20px;
  margin-bottom: 16px;
}
.page-index {
  padding-bottom: 100px !important;
}
</style>
